
// Used to list all links as constants
export const kAppStoreLink = "https://apps.apple.com/fr/app/ummia/id1582867232"
export const kPlayStoreLink = "https://play.google.com/store/apps/details?id=fr.android.ummia"